import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { access, departments, rights } from "../../../utils/enoms";
import { useState } from "react";
import { toast } from "react-toastify";
import { authanticatedUser, branches, capitalizeFirstLetter } from "../../../utils/helper";
import {
  // faEdit,
  faClose,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";
import { createAdminUser } from "../../../redux/actions/admins";


export default function CreateAdminUserModal({ options }) {

  const diapatch = useDispatch();
  const { openCreateAdminUserModal, setOpenCreateAdminUserModal } = options;
  const [role, setRole] = useState('');
  const [username, setUsername] = useState('');
  const [position, setPosition] = useState('');
  const [branch, setBranch] = useState('');
  const [accessModule, setAccessModule] = useState({});

  const testCancle = async () => {
    setOpenCreateAdminUserModal(false);
    // return <Navigate replace to="/login" />;
  };

  const tmpCreateAdUser = () => {
    if(!username || username.length < 3){
      toast.error('Username is required');
      return;
    }

    if(!position){
      toast.error('Position is required');
      return;
    }

    if(!branch){
      toast.error('Branch is required');
      return;
    }

    if(!access ){
      toast.error('Admin permission is required');
      return;
    }

    const tmpAd = {
      username,
      role,
      position,
      accessModules: accessModule,
      token: authanticatedUser.token
    }
    // console.log(tmpAd)
    diapatch(createAdminUser(tmpAd))
    testCancle()
  }



  const handleModuleRights = (right, mod) => {

    const nextAccessModule = accessModule;

    if(!role){
      toast.error('Department is required');
      return
    }

    if(mod.rights.includes(right)){
      toast.error(right + ' right already included for '+ mod.name)
    }else{
      nextAccessModule.rights.push(right)
    toast.success(right + ' right added to ' + mod.name + ' Module')
    
    setAccessModule(nextAccessModule);
    }
  }

  const removeFromAccessModule = (item) => {
    // setAccessModule(accessModule.rights.filter((data)=> data !== item ))
  }

  const changeDepartment = (e) => {
    e.preventDefault()
     setRole(e.target.value)
     if(e.target.value === 'it'){
      setAccessModule(access[0])
     }else{
      setAccessModule(access[1])
     }
  }

  return (
    <Dialog
      open={openCreateAdminUserModal}
      onClose={setOpenCreateAdminUserModal}
      className="relative z-20"
    >
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4 grid-cols-2 gap-4">
              <DialogTitle
                as="h3"
                className="text-lg mb-5 font-bold text-gray-900"
              >
                Create Admin User
              </DialogTitle>

              <div className="col-span-1">
                <label
                  htmlFor="last-name"
                  className="block text-sm font-bold text-gray-900"
                >
                  Enter AD username
                </label>
                <div className="mt-4">
                  <input
                    id="last-name"
                    name="last-name"
                    type="text"
                    autoComplete="username"
                    onChange={e => setUsername(e.target.value)}
                    value={username}
                    placeholder="Enter username. Eg: jflomo"
                    className="block w-full pl-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
                </div>
                <div className="mt-4">
                  <input
                    id="position"
                    name="position"
                    type="text"
                    autoComplete="position"
                    placeholder="Enter Position. Eg: Database Administrator"
                    onChange={e => setPosition(e.target.value)}
                    value={position}
                    className="block w-full pl-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600  sm:leading-6"
                  />
                </div>

                <div className="mt-4">
                <select id="branch" onChange={e => setBranch(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                  <option selected>Select branch</option>
                  {branches?.map((branch, i) =>
                    <option value={branch} key={i}>{capitalizeFirstLetter(branch + ' ')} branch </option> 
                  )}
                </select>
                </div>

                <div className="mt-4">
                <select id="department" onChange={e => changeDepartment(e)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                  <option selected>Select Department</option>
                  {departments?.map((dept, i) =>
                    <option value={dept.role} key={i}>{dept?.name}</option> 
                  )}
                </select>
                </div>

                <div className="mt-4">
                  <select id="accessModules" onChange={e => setAccessModule(e.target.value)} disabled={true} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                    {!accessModule?.name ? <option>Select Right</option> : <option>{accessModule?.name}</option> }
                    {access?.map((mod, i) =>
                      <option value={mod.value} key={i}>{mod?.name}</option> 
                    )}
                  </select>
                </div>

                <div className="mt-4">
                <label
                  htmlFor="rights"
                  className="block text-sm font-bold text-gray-900"
                >
                  Rights
                </label>
                  <select id="rights" onChange={e => handleModuleRights(e.target.value, accessModule)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                    <option>Select Right</option>  
                    {rights?.map((item, i) =>
                      <option value={item} key={i}>{item}</option> 
                    )}
                  </select>
                </div>

                <div className="mt-4 ml-4 grid grid-cols-4 gap-4">
                    {accessModule?.rights?.map((item, i) => (
                      <div value={item} key={i}> {item} <button onClick={() => removeFromAccessModule(item)}><FontAwesomeIcon
                      icon={faClose}
                      className="mr-1"
                    /></button></div>
                    ))}
                </div>

              </div>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
              <button
                type="button"
                onClick={tmpCreateAdUser}
                disabled={authanticatedUser?.accessModules[0]?.rights?.includes('create') ? false : true}
                className="inline-flex w-full justify-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 sm:ml-3 sm:w-auto"
              >
                Add Admin
              </button>
              <button
                type="button"
                data-autofocus
                onClick={() => testCancle()}
                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
              >
                Cancel
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
